import { FeatureMouseInteraction } from '@openlayers/interaction/FeatureMouseInteraction';
import { MapOverlays } from '@openlayers/ol-overlays';
import { setMapCursor } from '@openlayers/ol-utils';
import { PipesLayer } from '@openlayers/pipes/PipesLayer';
import { mapUI } from '@pages/map/map';
import { jsonToHtml } from '@shared/utils/utils-html';
import Feature from 'ol/Feature';


export class PipeDesktopMouseInteraction extends FeatureMouseInteraction<PipesLayer> {

    onClick = (feature: Feature, e, n): void => {
        let props = feature.get('props');
        const treeNode = mapUI.mapPanels.panels.models.tree.getById(feature.get('source').modelId);

        if (props.slope) {
            try {
                props.slope = parseFloat(props.slope).toFixed(2) + '%';
            } catch { }
        }

        if (treeNode) {
            props = {
                [kuura.getMessage('tablet.filename_js')]: treeNode.text,
                ...props
            };
        }

        MapOverlays.showDialog(this.map, '<div class="right"><i class="iki iki-cross" onclick="mapUI.hideDialog()"></i></div>' + jsonToHtml(props), e, n);
    };

    onMouseOver = (feature: Feature, e, n): void => {
        setMapCursor(this.map, 'pointer');
    };
}
